/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_CollectionsInputs */

const en_directory_footer_link_collections = /** @type {(inputs: Directory_Footer_Link_CollectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections`)
};

const zh_directory_footer_link_collections = /** @type {(inputs: Directory_Footer_Link_CollectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集`)
};

/**
* | output |
* | --- |
* | "Collections" |
*
* @param {Directory_Footer_Link_CollectionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_collections = /** @type {((inputs?: Directory_Footer_Link_CollectionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_CollectionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_collections(inputs)
	return zh_directory_footer_link_collections(inputs)
});
export { directory_footer_link_collections as "directory.footer.link_collections" }